import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AtsWhatsappChannelTab from './AtsWhatsappChannelTab';
import AtsWhatsappFreeTab from './AtsWhatsappFreeTab';

/**
 * WhatsApp en un solo lugar. Son dos cosas distintas —el número por el que
 * opera la organización, y los textos con que responde el bot— pero tener dos
 * pestañas llamadas "WhatsApp" en el menú confundía. Van como sub-pestañas.
 * Cada una guarda por su cuenta: son endpoints distintos.
 */
const AtsWhatsappTab = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(e, v) => setTab(v)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label={t('ats.config.whatsappTabs.channel')} sx={{ minHeight: 44 }} />
        <Tab label={t('ats.config.whatsappTabs.messages')} sx={{ minHeight: 44 }} />
      </Tabs>

      {tab === 0 && <AtsWhatsappChannelTab />}
      {tab === 1 && <AtsWhatsappFreeTab />}
    </Box>
  );
};

export default AtsWhatsappTab;
